import React from 'react';
import { SearchIcon } from '../ios/IOSIcons';
import { trackSearchEvents } from '../../../../lib/analyticsEnhanced';

interface TaskSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  placeholder?: string;
  scope?: string; // 搜索范围，用于分析
}

/**
 * iOS 风格的搜索栏
 */
export const TaskSearchBar: React.FC<TaskSearchBarProps> = ({
  value,
  onChange,
  onFocus,
  onBlur,
  placeholder = "搜索",
  scope = "tasks",
}) => {
  // 处理搜索输入变化
  const handleChange = (newValue: string) => {
    onChange(newValue);

    // 如果是清空搜索，记录搜索清除事件
    if (value && !newValue) {
      trackSearchEvents.searchCleared(value, { scope });
    }
  };

  // 处理搜索提交（回车键）
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && value.trim()) {
      // 这里需要从父组件传入结果数量，暂时设为0
      trackSearchEvents.searchPerformed(value.trim(), scope, 0, {
        trigger: 'enter_key'
      });
    }
  };

  // 处理清除按钮点击
  const handleClear = () => {
    trackSearchEvents.searchCleared(value, {
      scope,
      trigger: 'clear_button'
    });
    onChange('');
  };

  return (
    <div className="relative">
      <div className="absolute left-3 top-2.5 w-5 h-5 text-ios-gray dark:text-ios-dark-gray">
        <SearchIcon />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        className="w-full h-10 pl-10 pr-4 bg-ios-gray5 dark:bg-ios-dark-gray4 rounded-ios-lg text-ios-body placeholder-ios-gray dark:placeholder-ios-dark-gray focus:outline-none"
      />
      {value && (
        <button
          onClick={handleClear}
          className="absolute right-3 top-2.5 w-5 h-5 bg-ios-gray3 dark:bg-ios-dark-gray3 rounded-full flex items-center justify-center text-white"
        >
          <svg className="w-3 h-3" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 3L3 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
    </div>
  );
};
